import { CheckoutConfig, CheckoutStepType } from 'haba-featurelibs/checkout/root';

export const CheckoutStepsConfig: CheckoutConfig = {
  checkout: {
    steps: [
      {
        id: 'shippingAddress',
        name: 'habaCheckoutProgress.shippingAddress',
        routeName: 'checkoutShippingAddress',
        iconPath: '/common/assets/icons/checkout/delivery.svg#svg',
        type: [CheckoutStepType.SHIPPING_ADDRESS],
      },
      {
        id: 'paymentDetails',
        name: 'habaCheckoutProgress.paymentDetails',
        routeName: 'checkoutPaymentDetails',
        iconPath: '/common/assets/icons/checkout/payment.svg#svg',
        type: [CheckoutStepType.PAYMENT_DETAILS],
      },
      {
        id: 'reviewOrder',
        name: 'habaCheckoutProgress.reviewOrder',
        routeName: 'checkoutReviewOrder',
        iconPath: '/common/assets/icons/checkout/overview.svg#svg',
        type: [CheckoutStepType.REVIEW_ORDER],
      },
    ],
  },
};
